import React from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownwardRounded';
import { useSearchParams } from 'react-router-dom';

import Responsive from 'src/components/responsive/Responsive';
import Flex from 'src/components/flex/Flex';
import Hotkey from 'src/components/hotkey/Hotkey';

export const getBackLabelFromPath = (path?: string | null): string => {
    const defaultTitle = 'Inbox';
    if (!path) {
        return defaultTitle;
    }
    if (path.split('?')[0].includes('archive')) {
        return 'Search';
    } else {
        return defaultTitle;
    }
};

/**
 * Display the available hotkeys to the user
 */
export default function LeadMessagesHotkeys() {
    const [searchParams, _] = useSearchParams();
    const backPath = searchParams.get('back_path');
    const backLabel = getBackLabelFromPath(backPath);

    return (
        <Responsive desktop>
            <div>
                <Flex p={1} pt={0} alignItems="center">
                    <Hotkey label={'Back to ' + backLabel}>
                        Esc
                    </Hotkey>

                    <Hotkey label="Next">
                        <ArrowDownwardIcon />
                    </Hotkey>

                    <Hotkey label="Previous">
                        <ArrowUpwardIcon />
                    </Hotkey>

                    <Hotkey label="Schedule a Tour">
                        T
                    </Hotkey>

                    <Hotkey label="Snippets">
                        S
                    </Hotkey>
                </Flex>
            </div>
        </Responsive>
    );
}
